import { defineMessage } from 'react-intl';

/** Shown when the edit was published to exactly one platform (name comes from social-export registry). */
export const editCardPublishedOnSinglePlatformMessage = defineMessage({
  id: 'videoEditions.editCard.publishedOnSinglePlatform',
  defaultMessage: 'Publicado en {platform}',
});

/** Shown when the edit was published to more than one platform. */
export const editCardPublishedInPlatformsMessage = defineMessage({
  id: 'videoEditions.editCard.publishedInPlatforms',
  defaultMessage: 'Publicado en {count, plural, one {# plataforma} other {# plataformas}}',
});
